<template>
  <div>
    <FormLabel
      v-if="label"
      v-bind="{
        label,
        required,
        disabled,
        description,
        descriptionType,
        dirty,
        error,
        id,
        status
      }"
    />
    <FormList
      ref="list"
      :value="value"
      :disabled="disabled"
      @input="$emit('input', $event)"
    >
      <!-- eslint-disable-next-line vue/no-unused-vars -->
      <template #default="{ isRead, isEdit, item, index, updateItem }">
        <!-- TODO Migrate to dynamicForms and introduce validation for nested fields -->
        <SchemaForm
          :disabled="disabled || isRead"
          :value="item"
          :fields="fields"
          @input="updateItem(index, $event)"
        />
      </template>
    </FormList>
    <AppButton
      v-if="!disabled"
      @click="add"
    >
      <AppIcon name="add" />
      <span>Add Career Path</span>
    </AppButton>
  </div>
</template>

<script>
import _without from 'lodash/without'
import FormList from './FormList'
import SchemaForm from './Form'
import FormContactsListActions from './FormContactsListActions'
import FormLabel from './FormLabel'
import FormMixin from './FormMixin'
import careerPathFields from '@/constants/specialTypesFields/careerPaths'

export default {
  inheritAttrs: false,
  mixins: [ FormMixin ],
  components: { FormList, SchemaForm, FormLabel },
  props: {
    value: {
      type: Array,
      default: () => [],
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    config: {
      type: Object,
      default: () => ({
        showLabel: false,
        useOnlyFieldsFromConfig: false,
      }),
    },
  },
  computed: {
    fields () {

      const defaultFields = careerPathFields({
        config: this.config,
      })

      const deleteField = {
        component: FormContactsListActions,
        class: 'mt-4',
        listeners: { delete: this.delete },
      }
      return [
        {
          ...defaultFields.name, style: 'flex-grow: 4',
        },
        {
          ...defaultFields.employers, style: 'flex-grow: 4',
        },
        {
          ...defaultFields.description, style: 'flex-grow: 3.5',
        },
        {
          ...defaultFields.showInCatalog, style: 'flex-grow: 3.5',
        },
        { ...deleteField, style: 'flex-grow: 0.1; flex-basis: 30px' },
      ]
    },
  },
  methods: {
    add () {
      this.$emit('input', [ ...(this.value || []), {} ])
    },
    delete (item) {
      this.$emit('input', _without(this.value, item))
    },
  },
}
</script>
